/*! @azure/msal-react v3.0.6 2025-03-11 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-react";
const version = "3.0.6";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
